// TODO(orange): upgrade this to typescript enum
export const STAGES = {
  LOGIN: 'LOGIN',
  SIGN_UP_COMPLETE: 'SIGN_UP_COMPLETE',
  PASSWORD_RECOVERY_COMPLETE: 'PASSWORD_RECOVERY_COMPLETE',
};
